import React from 'react'
import classnames from 'classnames';
import {Switch, Checkbox } from 'antd'
import './index.scss';
import {validateCheckDigit} from '../../helpers/validation'
import InputField from '../InputField';
import InputRange from '../InputRange';

const Calculator = ({cur, changeCurrency, sum, changeSum, term, changeTerm, replenishment, changeReplenishment, early, changeEarly, procent, changeProcentEndTerm, tax, changeTax, result}) => {
    
    const formatEndTerm = (value) => {
        if(!value) {
            return
        }
        const values = value.toString().split('.');
        if(!values) {
            return value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
        if(values[1]) {
            return `${values[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")},<span class="calculator__result-value--small">${values[1]} ${cur.toUpperCase()}</span>`;
        }
        return `${values[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ")}<span class="calculator__result-value--small"> ${cur.toUpperCase()}</span>`;
    }
    
    return (
        <div className='calculator calculator--deposit'>
            <div className="calculator__wrapper">
                <div className="calculator__controls">
                    <div className="calculator__control calculator__control--currency">
                        <label className={'calculator__control-label'}>Валюта</label>
                        <div className="calculator__control-wrapper">
                            <div onClick={() => changeCurrency('uah')} className={classnames("calculator__control-btn bold", {'calculator__control-btn--current': cur === 'uah'})}>UAH</div>
                            <div onClick={() => changeCurrency('usd')} className={classnames("calculator__control-btn bold", {'calculator__control-btn--current': cur === 'usd'})}>USD</div>
                            <div onClick={() => changeCurrency('eur')} className={classnames("calculator__control-btn bold", {'calculator__control-btn--current': cur === 'eur'})}>EUR</div>
                        </div>
                    </div>
                    <div className="calculator__control calculator__control--sum">
                        <InputField min={cur === 'uah' ? 1000 : 100} message={'Перевірте правильність вводу cуми'} maxLength={8} style={{maxWidth: '360px'}} type={'sum'} checkedFunc={validateCheckDigit} title={`Сума, ${cur.toUpperCase()}`} placeholder="Введіть суму депозиту" value={sum} change={changeSum} />
                    </div>
                    <div className="calculator__control calculator__control--term">
                        <InputRange title={'Термін дії'} max={8} min={1} step={1} value={[term]} change={changeTerm} />
                        <div className="calculator__control-info">
                            <span>7 днів</span>
                            <span>1м</span>
                            <span>3м</span>
                            <span>6м</span>
                            <span>9м</span>
                            <span>12м</span>
                            <span>18м</span>
                            <span>24м</span>
                        </div>
                    </div>
                    <div className="calculator__control-wrapper">
                        <div className="calculator__control calculator__control-switch">
                            <label className={'calculator__control-label'}>Поповнення</label>
                            <div className="medium">
                                ні
                                <Switch checked={replenishment} onChange={changeReplenishment} />
                                так
                            </div>
                            <div className="calculator__control-help-text">
                            Поповнення вкладу можливе в 1/2 строку дії депозитного договору.<br />
Максимальна сума щомісячного поповнення - не більше початкової суми депозиту
                            </div>
                        </div>
                        <div className="calculator__control calculator__control-checkbox">
                            <label className={'calculator__control-label'}>Виплата процентів</label>
                            <div className={'calculator__control-checkbox--wrapper'}>
                                <Checkbox checked={early} onChange={() => changeEarly(true)}>в кінці строку</Checkbox>
                                <Checkbox checked={!early} style={{marginLeft: 0}} onChange={() => changeEarly(false)}>щомісячно</Checkbox>
                            </div>
                        </div>
                    </div>
                    <div className="calculator__control calculator__control-switch calculator__control-switch--early">
                        <label className={'calculator__control-label'}>Дострокове зняття</label>
                        <div className="medium">
                            ні
                            <Switch checked={procent} onChange={changeProcentEndTerm} disabled />
                            так
                        </div>
                        
                    </div>
                    <div className="calculator__control-help-text calculator__control-help-text--early">
                        { procent && `Для вкладів строком від 3 місяців. Дострокове розірвання можливе через 35 днів від дати розміщення вкладу (дати останньої пролонгації)`}
                    </div>
                </div>
                <div className="calculator__results">
                    <div className="calculator__result calculator__result-large">
                        <div className="calculator__result-label">
                            Ви отримаєте:
                        </div>
                        <div className="calculator__result-value" dangerouslySetInnerHTML={{__html: result !== null ? (!result.endTerm && result.endTerm < 0) ? '--' : `${formatEndTerm(result.endTerm)}` : '--'}}>
                        </div>
                    </div>
                    <div className="calculator__result calculator__result-checkbox">
                        Розрахувати з урахуванням податків
                        <Checkbox onChange={() => changeTax(!tax)} checked={tax} />
                    </div>
                    <div className="calculator__result">
                        <div className="calculator__result-label">
                            Процентна ставка
                        </div>
                        <div className="calculator__result-value">
                            {result ? (!result.percent && result.percent < 0) ? '--' : `${result.percent}%` : '--'}
                        </div>
                    </div>
                    <div className="calculator__result">
                        <div className="calculator__result-label">
                            Процентна ставка за вкладом (депозитом) з урахуванням сплати податків
                        </div>
                        <div className="calculator__result-value">
                            {result ? (!result.taxWithholdingRate && result.taxWithholdingRate < 0) ? '--' : `${result.taxWithholdingRate}%` : '--'}
                        </div>
                    </div>
                    <div className="calculator__result">
                        <div className="calculator__result-label">
                            Сумарний дохід
                        </div>
                        <div className="calculator__result-value">
                            {result ? (!result.amount && result.amount < 0) ? '--' : `${result.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${cur.toUpperCase()}` : '--'}
                        </div>
                    </div>
                    <div className="calculator__result">
                        <div className="calculator__result-label">
                            Ставка оподаткування:
                        </div>
                        <div className="calculator__result-value">
                            19.50%
                        </div>
                    </div>
                    {tax && <div className="calculator__result">
                        <div className="calculator__result-label">
                            Податок
                        </div>
                        <div className="calculator__result-value">
                        {result ? (!result.payTaxes && result.payTaxes < 0) ? '--' : `${result.payTaxes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${cur.toUpperCase()}` : '--'}
                        </div>
                    </div>}
                    {tax && <div className="calculator__result">
                        <div className="calculator__result-label">
                            Прибуток після оподаткування:
                        </div>
                        <div className="calculator__result-value">
                        {result ? (!result.profit && result.profit < 0) ? '--' : `${result.profit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${cur.toUpperCase()}` : '--'}
                        </div>
                    </div>}
                    <div className="calculator__result">
                        <div className="calculator__result-label">
                            Сума в кінці строку*
                        </div>
                        <div className="calculator__result-value">
                        {result ? (!result.endTerm && result.endTerm < 0) ? '--' : `${result.endTerm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} ${cur.toUpperCase()}` : '--'}
                        </div>
                    </div>
                    <div className="calculator__result calculator__result-help-text">
                        *прогнозований розрахунок прибутку після оподаткування <br /> <i style={{display: 'block', marginTop: '4px'}}>Сума доходу та податку з отриманого прибутку є орієнтовною</i>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Calculator;